<template>
    <div class="page">
        <header class="pageHeader rounded darken">
            <fade-image class="darken" src="assets/headers/profile.png" />
        </header>

        <div class="scroller2">
            <div v-if="message">
                <header>
                    <h2 v-if="!message"><span style="color: #eef5f2">_</span></h2>
                    <h2 v-else-if="message.from.id == user.id">
                        <template v-if="message.to_group_id">
                            {{ message.group.name }}
                        </template>
                        <template v-else>
                            {{ message.to.first_name }} {{ message.to.last_name }}
                        </template>
                    </h2>
                    <h2 v-else class="small">
                        {{ message.from.first_name }} {{ message.from.last_name }}
                    </h2>
                    <ul class="links">
                        <li>
                            <a href="" class="cancel" @click.prevent="$router.go(-1)"
                                ><x-icon class="icon"
                            /></a>
                        </li>
                    </ul>
                </header>

                <span class="sender">
                    <span class="info large" style="margin-bottom: 10px">{{
                        this.$date(message.created_at).format("ddd D MMM")
                    }}</span>
                </span>

                <div class="content">
                    {{ message.message }}

                    <br />
                    <router-link to="" v-if="message.offer">{{ message.offer.title }}</router-link>
                    <br /><br />

                    <img class="image" v-if="message.image" :src="imageURL(message.image)" alt="" />
                </div>
            </div>

            <button @click.prevent="deleteMessage" :disabled="busy" class="button red">
                {{ busy ? "Please wait..." : "Delete message" }}
            </button>
        </div>
    </div>
</template>

<script>
import { imageURL } from "@/mixins/imageURL.js";
import FadeImage from "@/components/App/fade-image";
import { XIcon } from "vue-feather-icons";
export default {
    name: "",
    mixins: [imageURL],
    components: { FadeImage, XIcon },
    data() {
        return {
            message: false,
        };
    },
    created() {
        this.getMessage();
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
    },
    methods: {
        getMessage() {
            window.axios.get("/message/" + this.$route.params.id).then((response) => {
                this.message = response.data;
                this.$store.dispatch("getMsgUnreadCount");
            });
        },
        deleteMessage() {
            this.$confirm(
                "Are you sure you want to delete this message?",
                () => {
                    this.busy = true;
                    window.axios
                        .delete("/message/" + this.$route.params.id)
                        .then(() => {
                            this.$notify("Message Deleted");
                            this.busy = false;
                            this.$store.dispatch("getMsgUnreadCount");
                            this.$router.go(-1);
                            // this.$router.push({ name: "proPlayerMessagesInbox" });
                        })
                        .catch(() => {
                            this.busy = false;
                        });
                },
                "Yes",
                "No",
            );
        },
    },
};
</script>

<style lang="scss" scoped>
.sender {
    display: block;
    margin-bottom: 10px;

    i {
        float: right;
        color: lighten(#000000, 80);
    }
    .from {
        color: $green_0;
    }
}
.image {
    max-width: 100%;
}
.content {
    line-height: 1.5;
    font-weight: 200;
    background: white;
    padding: 17px;
    border-radius: $radius;
    margin-bottom: 30px;
    color: $green_0;
    a,
    span {
        text-decoration: none;
        color: $green_1;
    }
}
</style>
